<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" class="pull-right" @click="$router.push('/admin/bedrijven/toevoegen')">
              Bedrijf toevoegen
            </b-button>
          </b-col>
        </b-row>
        <resource-index header="Bedrijven" endpoint="companies" show-route="companies.view" add-route="companies.create"></resource-index>
      </div>
    </div>
  </div>
</template>
<script>
import ResourceIndex from '../../components/ResourceIndex';

export default {
  name: 'companies',
  components: { ResourceIndex },
}

</script>
